const defDataGeneral = {
  orders: [],
  notOrders: [],
  routes: [],
  allOrders: [],
};

const defDataGps = {
  gps: [],
  notGps: 0,
  polyline: [],
  initPoint: null,
  endPoint: null,
};

const defShowMarker = {
  order: true,
  notOrder: false,
  route: false,
  allMarkers: false,
};
const defDataQuota = { processAmt: 0, pendingAmt: 0, customers: 0 };

const optionsPolyline = {
  strokeColor: '#ff0052',
  strokeOpacity: 0.5,
  strokeWeight: 3,
  visible: true,
};

const defMapCenter = {
  lat: -14.07543457346045,
  lng: -75.73423487506565,
};

export { defDataGeneral, defDataGps, defShowMarker, defDataQuota, optionsPolyline, defMapCenter };
